"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _index = require("../index.js");
var _PermissionForm = _interopRequireDefault(require("../PermissionForm"));
var _pawnsByRole = _interopRequireDefault(require("./pawnsByRole.graphql"));
var _pawnsByRoleAsSuper = _interopRequireDefault(require("./pawnsByRoleAsSuper.graphql"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var AppDefs = window.cccisd.appDefs;
var PermissionFormConvertProps = function PermissionFormConvertProps(_ref) {
  var closeModal = _ref.closeModal,
    loadData = _ref.loadData,
    selectedRows = _ref.selectedRows;
  var initialValues = {};
  _index.permissionsData.forEach(function (pData) {
    initialValues[pData.permission] = false;
  });
  return /*#__PURE__*/_react["default"].createElement(_PermissionForm["default"], {
    closeModal: closeModal,
    initialValues: initialValues,
    loadData: loadData,
    pawnIds: selectedRows
  });
};
var AddPawnRule = function AddPawnRule(_ref2) {
  var closeModal = _ref2.closeModal,
    loadData = _ref2.loadData;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRole = _useState2[0],
    setSelectedRole = _useState2[1];
  var appdefRoles = AppDefs.pawn.roles || [];
  appdefRoles = appdefRoles.filter(function (r) {
    return r.isFortressUser && !['respondent'].includes(r.handle);
  });
  var baseColumns = [{
    name: 'user.username',
    label: 'Username',
    sort: true,
    filter: true
  }, {
    name: 'user.firstName',
    label: 'First Name',
    sort: true,
    filter: true
  }, {
    name: 'user.lastName',
    label: 'Last Name',
    sort: true,
    filter: true
  }, {
    name: 'parentGroup.anyGroup.group.label',
    label: 'Group',
    sort: true,
    filter: true
  }];
  var importantColumns = [];
  var roleDef = appdefRoles.find(function (item) {
    return item.handle === selectedRole;
  }) || {};
  var importantFields = roleDef.importantFields || [];
  var _iterator = _createForOfIteratorHelper(importantFields),
    _step;
  try {
    var _loop = function _loop() {
      var f = _step.value;
      if (baseColumns.find(function (c) {
        return c.name === f.path;
      })) {
        return 1; // continue
      }
      importantColumns.push({
        name: "important.".concat(f.path),
        label: f.label,
        sort: true,
        filter: true
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }

    /* /////////////////////////////////////////////////////////////////////////
    // RENDER-RELATED /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var roleSelector = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label"
  }, "Select Role"), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
    data: [{
      label: '--- Choose a Role ---',
      handle: ''
    }].concat(_toConsumableArray(appdefRoles)),
    itemComponent: function itemComponent(_ref3) {
      var item = _ref3.item;
      return item.label;
    },
    onChange: function onChange(r) {
      setSelectedRole(r.handle);
    },
    value: selectedRole,
    valueComponent: function valueComponent(_ref4) {
      var item = _ref4.item;
      return item && item.label || null;
    },
    valueField: "handle"
  }));
  var renderTable = function renderTable(_ref5) {
    var renderDefault = _ref5.renderDefault,
      selectedRows = _ref5.selectedRows;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderDefault(), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].fieldSpacing
    }, /*#__PURE__*/_react["default"].createElement(PermissionFormConvertProps, {
      closeModal: closeModal,
      loadData: loadData,
      selectedRows: selectedRows
    })));
  };
  var isSuperUser = Fortress && Fortress.isSuperUser();
  var userTable = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fieldSpacing
  }, /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], {
    key: "permissions",
    columns: [].concat(baseColumns, importantColumns),
    graphqlVariables: {
      roleHandle: selectedRole
    },
    query: isSuperUser ? _pawnsByRoleAsSuper["default"] : _pawnsByRole["default"],
    render: renderTable,
    rowActions: [{
      name: 'addRule',
      action: function action() {}
    }],
    rowKey: "pawn.pawnId",
    showRowActions: false
  }));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, roleSelector, selectedRole && userTable);
};
AddPawnRule.propTypes = {
  closeModal: _propTypes["default"].func,
  loadData: _propTypes["default"].func
};
var _default = exports["default"] = AddPawnRule;